import { colors } from 'fitify-ui'
import { styled } from 'styled-components'

export const StyledForm = styled.form<{ isFullWidth?: boolean }>`
  display: grid;
  width: 100%;
  max-width: 800px;
  gap: 16px 24px;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 768px) {
    gap: 16px;
    grid-template-columns: 1fr;
  }
`

export const StyledInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`

export const StyledInput = styled.input`
  padding: 12px;
  border: 1px solid ${colors.Gray300};
  border-radius: 8px;

  font-family: 'Graphik LCG Web', sans-serif;
  font-size: 16px;
  &:focus {
    border-color: ${colors.Blue400};
    outline: none;
  }

  &:invalid {
    border-color: ${colors.Red400};
  }
`

export const StyledErrorMessage = styled.span`
  color: red;
  font-size: 12px;
`

export const StyledSelect = styled.select`
  padding: 12px;
  border: 1px solid ${colors.Gray300};
  border-radius: 8px;

  /* Remove default arrow */
  -moz-appearance: none; /* for Firefox */
  -webkit-appearance: none; /* for Chrome */
  appearance: none; /* for Edge */

  font-family: 'Graphik LCG Web', sans-serif;
  font-size: 16px;
  &:focus {
    border-color: ${colors.Blue400};
    outline: none;
  }

  &:invalid {
    border-color: ${colors.Red400};
  }
`

export const StyledSelectErrorMessage = styled.span`
  color: red;
  font-size: 12px;
`

export const StyledToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

export const StyledToggleSwitch = styled.div<{ $isActive: boolean }>`
  position: relative;
  width: 50px;
  height: 25px;
  border-radius: 25px;
  background-color: ${(props) =>
    props.$isActive ? colors.Green500 : colors.Red400};
  cursor: pointer;
  transition: background-color 0.3s;

  &::before {
    position: absolute;
    top: 2px;
    left: ${(props) => (props.$isActive ? '26px' : '2px')};
    width: 21px;
    height: 21px;
    border-radius: 50%;
    background-color: white;
    content: '';
    transition: left 0.3s;
  }
`
